@for (cinema of data().cinemas; track cinema.id_cinema) {
  @let cinemasScreensLength = cinema.screens?.length;
  @for (screen of cinema.screens; track screen.screen_id) {
    <td
      app-planning-region-empty-cell
      [screen]="screen"
      [data]="data()"
      [wednesday]="wednesday()"
      [dateValue]="dateValue()"
      [ngClass]="{'td-cinema': cinemasScreensLength == ($index + 1)}">
    </td>
  }
}
